( function($) {

	var app = {

		initFixedHeader: function(){
			// $('#ip-district-header').waypoint(function(direction) {
			// 	if (direction === 'down') {
			// 		$('#ip-district-header').addClass('scrolled');
			// 	}else{
			// 		$('#ip-district-header').removeClass('scrolled');
			// 	}
			// },{offset: '5%'});
		},

		initSlider: function(){
			$('.ip-district-carousel-slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '9%',
				dots: false,
				arrows: true,
				infinite: true,
				autoplay: false,
				autoplaySpeed: 3000,
				speed: 900,
				pauseOnHover: false,
				prevArrow: '.ip-district-carousel-controls .prev',
				nextArrow: '.ip-district-carousel-controls .next',
				focusOnSelect: true,
			 });
		},

		initCarousel: function(){
			$('.ip-district-bikecarousel-slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '14%',
				dots: false,
				arrows: true,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3000,
				speed: 900,
				pauseOnHover: false,
				prevArrow: '.ip-district-bikecarousel-controls .prev',
				nextArrow: '.ip-district-bikecarousel-controls .next',
				focusOnSelect: true,
				responsive: [
				{
					breakpoint: 992,
						settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '9%',
					}
				}
				]
			 });
		},

        initFunctions: function() {

            if( jQuery('#features .ip-grid-cta-row > .ip-grid-cta-item').length > 0 ) {
  
                var divs = jQuery('#features .ip-grid-cta-row .ip-grid-cta-item');
              
                for(var i = 0; i < divs.length; i+=3) {
                
                    divs.slice(i, i+3).wrapAll('<div class="ip-grid-cta-col"></div>');
                }
            }

            if( window.location.href.indexOf('/district') > -1 && jQuery('.ip-district-product-main > .ip-district-product-item').length > 0 ) {

                jQuery('.ip-district-product-main > .ip-district-product-item').each(function(){

                    if( jQuery(this).find('.ip-district-product-colors .color-options > button').length > 0 ) {
        
                        jQuery(this).find('.ip-district-product-img .featured-image').remove();

                        var get_color = jQuery(this).find('.bike-img.variant-image.active').attr('data-color');

                        jQuery('.ip-district-product-colors .color-options button.' + get_color).addClass('active');
                      
                    } else {
        
                        jQuery(this).find('.ip-district-product-img .variant-image').remove();
                    }
                });
            }

            // window.location.href.indexOf('/pages/district') > -1 &&

            if( jQuery('.ip-district-product-main > .ip-district-product-item').length > 0 ) {

                jQuery('.ip-district-product-main > .ip-district-product-item').each(function(){

                    var this_bike = jQuery(this);

                    if( this_bike.find('.ip-district-product-colors .color-options > button').length > 0 ) {
        
                        this_bike.find('.ip-district-product-img  .featured-image').remove();

                        var get_color = this_bike.find('.bike-img.variant-image.active').attr('data-color');

                        jQuery('.ip-district-product-colors .color-options button.' + get_color).addClass('active');
                      
                    } else {
        
                        jQuery(this).find('.ip-district-product-img  .variant-image').remove();

                        jQuery(this).find('.ip-district-product-img  .featured-image').addClass('active');
                    }
                });
            }
        }
	}

	
	$(document).ready( function() {
		app.initSlider();
		app.initCarousel();
		// app.initFixedHeader();

        app.initFunctions();
	});
	
	$(window).on('load', function(){

	});

})(jQuery);